export default __webpack_public_path__ + "static/media/history.a34b9b5d.svg";